/**
 * CalendarPanel Component - MA-ARCH-161
 * 
 * Extracted from ScriptPlay.jsx - Calendar panel for the Quick Reference side panel.
 * Displays a date picker with selected date display.
 */

import React from 'react';
import { CardContent } from '@/components/ui/card';
import { Calendar } from '@/components/ui/calendar';

/**
 * @param {Object} props
 * @param {Date|null} props.selected - Currently selected date
 * @param {Function} props.onSelect - Callback when date is selected: (date: Date|null) => void
 */
export function CalendarPanel({ selected, onSelect }) {
  return (
    <CardContent
      className="min-h-0 flex-1 overflow-y-auto pt-4"
      data-testid="quick-reference-calendar"
    >
      <div className="space-y-3">
        <div className="rounded-2xl border border-white/10 bg-white/5 p-3">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={(d) => onSelect(d || null)}
            className="text-slate-100"
            classNames={{
              caption_label: "text-sm font-medium text-slate-100",
              head_cell: "text-slate-200/80 rounded-md w-8 font-normal text-[0.8rem]",
              nav_button: "h-7 w-7 bg-white/5 p-0 text-slate-100 opacity-80 hover:opacity-100",
              day: "h-8 w-8 p-0 font-normal text-slate-100 aria-selected:opacity-100",
              day_today: "bg-white/10 text-slate-100",
              day_outside: "day-outside text-slate-200/50 aria-selected:bg-white/10 aria-selected:text-slate-200/50",
              day_selected: "bg-indigo-500 text-white hover:bg-indigo-500 hover:text-white focus:bg-indigo-500 focus:text-white",
            }}
          />
        </div>

        <div className="text-sm text-slate-200/80">
          Selected: {selected ? selected.toLocaleDateString() : "—"}
        </div>
      </div>
    </CardContent>
  );
}

export default CalendarPanel;
